festivalHandler = {
    $tabsContent: $('#tabs-content'),
    $lineupTabs: $('#lineup-tabs'),
    $panelLineUp: $('.panel-line-up'), 
    $itemFilterDate: $('.item-filter-date'),
    $panelSingleChefContainer: $('.panel-single-chef-container'),  
    $ddContainer : $('.drop-down-container'),
    $closeSingle : $('[href="#close-single-chef"]'),
    $openLineup: $('[href="#open-lineup"]'),
    $profileTab: $('[href="#profile"]'),
    $customMagellan: $('.custom-magellan'),
    $lineUpTab: $('[href="#lineup"]'),
    $ticketLineUp: $('.button-lineup'),
    $ticketBtn: $('.button-ticket'),
    $ticketsTab: $('[href="#tickets"]'),
    $singleChef: $('.single-chef'),
    lineupContentTop : 0,

    customMagellan: function(){
        var self = this;
        var screenTop = $(document).scrollTop();

        if (self.$customMagellan.length > 0) {
            self.$customMagellan.find('[data-magellan-target]').each(function(){
                var contentTop    = $(this).position().top - 10;
                var contentHeight = $(this).outerHeight();
                var id = $(this).data('magellan-target');
                var $menuActive   = self.$customMagellan.find('.internal-nav').find('[href*="#'+id+'"]');

                if ((screenTop > contentTop) && (screenTop < (contentHeight + contentTop)) && (!$menuActive.hasClass('is-active')) ) {
                    self.$customMagellan.find('.internal-nav').children().removeClass('is-active');
                    $menuActive.addClass('is-active');
                }
            })
        } 
    },

    rescaleThumbnailName: function() {
        var self = this;
        
        setTimeout(function() {
            if ($('.custom-styled-thumbnail.has-thumbnail').length > 0 && $('.custom-styled-thumbnail.has-thumbnail').parents('.panel-single-chef.is-logo').length == 0) {
                $('.custom-styled-thumbnail.has-thumbnail').each(function() {
                    var selfParent  = this;
                    var $img        = $(this).find('.chef-thumbnail');
                    var $thumbName  = $(this).find('.thumbnail-name');
    
                    $($thumbName).each(function() {
                        var wScale          = $img.width() / $(this).width();
                        var hOri            = $(this).height();
                        var hOriScaled      = (hOri * wScale) + 26;
                        var hDiff           = hOriScaled - hOri;
                        var leftPos         = ($(selfParent).width() - $img.width()) / 2;
    
                        if ($(this).hasClass('first-name')) {
                            let topAddon = 14;
                            $($img).css({
                                'margin-top' : (hOriScaled + topAddon)+'px',
                            });
    
                            $(this).css({
                                'transform' : 'scale('+wScale+')',
                                'left'      : leftPos+'px',
                                'top'       : ((hDiff / 2)+(topAddon/2))+'px',
                            });
                        }
    
                        if ($(this).hasClass('last-name')) {
                            $($img).css({
                                'margin-bottom' : hOriScaled+'px',
                            });
    
                            $(this).css({
                                'transform' : 'scale('+wScale+')',
                                'left'      : leftPos+'px',
                                'bottom'    : (hDiff / 2)+'px',
                            });
                        }
                        
                    });
                    $(this).children().css('opacity', '1');
                });
            } else {
                $('.chef-thumbnail').css('opacity', '1');
            }
        }, 400);
    },

    filterLineUp: function(){
        var self = this;
        var $itemLineUpContainer = self.$panelLineUp.find('.item-line-up-container');

        if (window.location.hash) {
            var $tabActive = $('a[href='+window.location.hash+']');
            if ($tabActive) {
                var text = $($tabActive.get(0)).text();
                self.$ddContainer.find('[href="#choose-item"]').html(text);
            }
        }       
        
        self.$itemFilterDate.on('click',  function(){
            let dataFilterDate     = $(this).data('filter-date');
            let dataFilterCategory = $(this).data('filter-category');
            let arrowColor = 'theme-icon';//$(this).parents('.panel-line-up').hasClass('is-annual-event') ? 'maroon' : 'dark-yellow';
            
            self.$itemFilterDate.removeClass('button-link icon-arrow-down is-active '+arrowColor);
            let $filterSelected = $(this); 
            if (dataFilterDate) {
                $filterSelected = $('[data-filter-date="'+dataFilterDate+'"]');
            } else if (dataFilterCategory) {
                $filterSelected = $('[data-filter-category="'+dataFilterCategory+'"]');
            } 
            $filterSelected.addClass('button-link icon-arrow-down is-active '+arrowColor);
            $itemLineUpContainer.children().addClass('hide');
            self.$panelLineUp.find('.panel-item-lineup').addClass('hide');

            if (dataFilterDate) {
                $itemLineUpContainer.find('[data-date*="'+dataFilterDate+'"]').removeClass('hide');
                
                self.$panelLineUp.find('.panel-item-lineup').each(function() {
                    if ($(this).find('.chef-item:not(.hide)').length > 0) {
                        $(this).removeClass('hide');
                    }
                })

            } else if (dataFilterCategory) {
                self.$panelLineUp.find('[data-category="'+dataFilterCategory+'"]').removeClass('hide');
                $itemLineUpContainer.children().removeClass('hide');
                
            } else {
                $itemLineUpContainer.children().removeClass('hide');
                self.$panelLineUp.find('.panel-item-lineup').removeClass('hide');
            }  
            peopleHandler.resizeThumbnail();
        })

        self.$openLineup.on('click', function(){
            var date = $(this).data('event-date');
            var category = $(this).data('event-category');
            if (date) {
                $('.item-filter-date[data-filter-date="'+date+'"]').click();
            } else if (category) {
                $('.item-filter-date[data-filter-category="'+category+'"]').click();
            } 
            mainHandler.internalLinkScroll('#lineup-section');
        })

        $itemLineUpContainer.children().on('click', function(){
            let dataID = $(this).data('open-chef-detail');
            let $parent = $(this).closest('.panel-item-lineup');
            let dataCat = $parent.data('category');
            let dataFestID = $(this).data('fest-id');
            let posTop = $(document).scrollTop();
            let isAnnualEvent = $('header').hasClass('is-annual-event');
            let isLogo = $parent.data('type') == 'logo';

            self.$panelSingleChefContainer.html('');
            $.ajax({
                type: 'post',
                url: myAjax.ajax_url,
                data: {
                    action: 'load_detail_chef',
                    id: dataID,
                    fest_id: dataFestID,
                    is_annual_event: isAnnualEvent,
                    is_logo: isLogo
                },
                success: function(response) {
                    var $resultHtml = response['html'];

                    self.$panelSingleChefContainer.html($resultHtml);
                    self.$panelSingleChefContainer.addClass('active');
                    $('html, body').animate({
                        scrollTop: 0
                    }, 0);
                    window.location.hash = '#profile';
                    //self.$profileTab.click();
                    self.$profileTab.closest('.festival-tab-container').addClass('is-single').removeClass('is-dropping');
                    
                    if (Foundation.MediaQuery.only("small")) {
                        //self.$ddContainer.find('[href="#trigger-item"]').click();
                    }

                    if (dataCat != 'chefs') {
                        self.$panelSingleChefContainer.find('.cooking-at-container').addClass('hide');
                    }

                    self.rescaleThumbnailName();

                    self.$panelSingleChefContainer.on('click', '[href="#close-chef"]', function(e){
                        e.preventDefault();
                        self.$lineUpTab.parents().click();
                        $('html, body').animate({
                            scrollTop: posTop
                        }, 0);
                    })
                }
            });
        }) 

        setTimeout(() => {
            self.$itemFilterDate.each(function(){
                if ($(this).hasClass('is-active')) {
                    $(this).click();
                }
            })
        }, 50);
    },

    singleAbout: function(){
        var self = this;
        $('.tabs-panel').on('click', '.item-cooking-at', function(){
            var target = $(this).data('set-focus');
            if (target) {
                self.$lineUpTab.parents().click();
                mainHandler.internalLinkScroll('#'+target);
            }
        })
    },

    showBgInit: function($obj) {
        var self = this;

        var $itemContainer = $obj.find('.festival-tab');
        if (Foundation.MediaQuery.only('small')) {
            $itemContainer = $obj.find('.festival-drop-down');
        }
        
        $obj.removeClass('is-ticket-tab');
        var title  = $itemContainer.find('.tabs-title.is-active').data('title')
        var showBg = $itemContainer.find('.tabs-title.is-active').data('show-bg');
        if ((title == 'tickets') || (window.location.hash == '#tickets')) {
            var tmpShowBg = $itemContainer.find('.tabs-title[data-title="tickets"]').data('show-bg');
            if (tmpShowBg) {
                showBg = tmpShowBg;
                $obj.addClass('is-ticket-tab');
            }
        }

        if (showBg === 1) {
            if (!$obj.hasClass('show-bg')) {
                $obj.addClass('show-bg');
            }
        } else {
            $obj.removeClass('show-bg');
        }
    },

    activateFoundationTabFromHash: function(hash) {
        if (hash && hash.includes('#')) {
            var $hashEl = $(hash);

            if ($hashEl.length > 0 && $hashEl.parents('.tabs-panel').length > 0) {
                var $hashParentEl = $hashEl.parents('.tabs-panel');
                var parentId      = $hashParentEl.attr('id');
                var $tabLink      = $hashParentEl.parents('.panel-upcoming-festival').find('.tabs-title[data-title="'+parentId+'"] a[href="#'+parentId+'"]');
                var $secLink      = $hashParentEl.find('.internal-nav a[href="'+hash+'"]');
            
                if ($tabLink.length && !$tabLink.parent().hasClass('is-active')) {
                    $tabLink.click();
                    $tabLink.parent().addClass('is-active');
                }

                if ($secLink.length) {
                    setTimeout(function() {
                        $secLink.click();
                    }, 100); 
                }
            }
        }
    },

    init : function() {
        var self = this;
        
        $(window).on('load scroll', function(e) {
            self.customMagellan();
        });

        $(window).on('load resize', function(e) {
            self.rescaleThumbnailName();
        });

        if (self.$singleChef.length == 0) {
            self.filterLineUp();
            self.singleAbout();

            /* self.$closeSingle.on('click', function(e) {
                e.preventDefault();

                history.go(-1);
            }); */

            self.$ticketLineUp.on('click', function(e) {
                e.preventDefault();
                $('html, body').scrollTop(0);
                self.$lineUpTab.parents().click();
                self.$ddContainer.find('[href="#choose-item"]').html('Lineup');
                let posTop = $('#line-up-content').position().top - 110;
                $('html, body').scrollTop(posTop);
            });

            self.$ticketBtn.on('click', function(e) {
                e.preventDefault();
                $('html, body').scrollTop(0);
                self.$ticketsTab.parents().click();
                self.$ddContainer.find('[href="#choose-item"]').html('Tickets');
                let posTop = $('#tickets-content').position().top - 40;
                $('html, body').scrollTop(posTop);
            });
            
            var hash = window.location.hash;
            if (hash) {
                self.activateFoundationTabFromHash(hash);
            }
            
            $(window).on('load', function(e) {
                if (hash) {
                    if (hash == '#profile') {
                        setTimeout(function() {
                            self.$lineUpTab.parents().click();
                        }, 800);
                    }

                    setTimeout(function() {
                        var $activetab = self.$tabsContent.find('.tabs-title.is-active');
                        if ($activetab) {
                            var showBg = $activetab.data('show-bg');
                            if (showBg == 0) {
                                self.$tabsContent.removeClass('show-bg');
                            }
                        }
                    }, 700);
                }
            });

            if (self.$tabsContent.length > 0) {
                self.$tabsContent.each(function() {
                    self.showBgInit($(this));
                    $(this).on('resize, change.zf.tabs', function(e) {
                        var $itemContainer = $(this).find('.festival-tab');
                        if (Foundation.MediaQuery.only('small')) {
                            $itemContainer = $(this).find('.festival-drop-down');
                        }

                        self.showBgInit($(this));
                        mainHandler.setImageSize();

                        $(window).resize();
                        $itemContainer.closest('.festival-tab-container').removeClass('is-single').removeClass('is-dropping');
                        /* $(window).trigger('load.zf.sticky'); */
                        // video handler
                        var $tabPanel = $('.tabs-panel.is-active');
                        var $videoContainer = $tabPanel.find('.video-container');
                        /* if (!$videoContainer.hasClass('played')) {
                            var $buttonPlay = $videoContainer.find('.button-play');
                            if ($buttonPlay.length > 0) {
                                $buttonPlay.click();
                            }
                        } */

                        setTimeout(function() {
                            var currId = $itemContainer.find('.tabs-title.is-active a').attr('href');
                            if ($(currId).length > 0) {
                                var sticky = $(currId).find('.sticky');

                                if (sticky.length > 0) {
                                    sticky.removeClass('is-at-bottom');
                                    sticky.addClass('is-at-top');
                                    sticky.css('top', 0);
                                }
                            }
                        }, 300);
                    });
                });
            }

            if (self.$lineupTabs.length > 0) {
                self.$lineupTabs.each(function(){
                    $(this).on('change.zf.tabs', function(e) {
                        var $cont   = $(this).find('.tabs-small-container');
                        var $tabPnl = $(this).find('.tabs-title:not(.is-active)');
                        var color   = $tabPnl.css('background-color');

                        $cont.attr('style', '');
                        if (color !== 'rgba(0, 0, 0, 0)') {
                            $(this).find('.tabs-small-container').css('background-color', color);
                        }
                    });
                })
            }

            self.$ddContainer.each(function() {
                var selfParent = $(this);
                var contParent = selfParent.parents('.festival-tab-container');
                var $chooseItem = selfParent.find('[href="#choose-item"]');
                var $triggerItem = selfParent.find('[href="#trigger-item"]');
                var $items = selfParent.find('.tabs-title>a');
                var startLabel = selfParent.find('.drop-down-title-container').data('start-label');
                var choosenLabel = startLabel;

                $triggerItem.on('click', function(e) {
                    e.preventDefault();
                    if (!contParent.hasClass('is-dropping')) {
                        //selfParent.addClass('is-active');
                        contParent.addClass('is-dropping');
                        $chooseItem.html(startLabel);
                    } else {
                        //selfParent.removeClass('is-active');
                        contParent.removeClass('is-dropping');
                        $chooseItem.html(choosenLabel);
                    }
                });

                $chooseItem.on('click', function(e) {
                    e.preventDefault();

                    if (!contParent.hasClass('is-dropping')) {
                        //selfParent.addClass('is-active');
                        contParent.addClass('is-dropping');
                        $chooseItem.html(startLabel);
                    } else {
                        var $startItem = selfParent.find('.tabs-title').first();
                        if ($startItem.hasClass('is-active')) {
                            $triggerItem.click();
                        } else {
                            $startItem.find('a').click();
                        }
                    }
                });

                $items.on('click', function(e) {
                    e.preventDefault();
                    var label = $(this).html();
                    choosenLabel = label;
                    //$chooseItem.html(label);
                    $triggerItem.click();
                });
            });
        }
    }
}